module.exports = __webpack_public_path__ + "batman.jpg?c66554fffef60a3c48c5f920b0c87489";


//////////////////
// WEBPACK FOOTER
// ./src/assets/batman.jpg
// module id = 163
// module chunks = 0